import { Injectable, inject } from '@angular/core';
import { filter, from, map, mergeMap, switchMap, take } from 'rxjs';

import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { FeatureToggleService } from 'ish-core/feature-toggle.module';
import { SkuQuantityType } from 'ish-core/models/product/product.helper';
import { whenTruthy } from 'ish-core/utils/operators';

import { CustomQuickorderFacade } from '../../custom-quickorder/facades/custom-quickorder.facade';
import { CrossSellingPopupService } from '../services/cross-selling-popup.service';

@Injectable({ providedIn: 'root' })
export class ExtendedQuickOrderFacade extends CustomQuickorderFacade {
  private popupService = inject(CrossSellingPopupService);
  private featureToggleService = inject(FeatureToggleService);
  private shoppingFacade = inject(ShoppingFacade);


  override addQuickOrderToBasket(quickOrderItems: SkuQuantityType[]) {
  super.addQuickOrderToBasket(quickOrderItems);

  this.featureToggleService.enabled$('crossSellingPopup').pipe(
    take(1),
    filter(Boolean),

    switchMap(() =>
      from(quickOrderItems).pipe(
        mergeMap(({ sku, quantity }) =>
          this.shoppingFacade.productLinks$(sku).pipe(
            whenTruthy(),
            take(1),
            map(links => ({ sku, quantity, links }))
          )
        )
      )
    )
  )
  .subscribe(({ sku, quantity, links }) => {
    if (links?.crossselling?.products?.length) {
      this.popupService.emitCrossSellingEvent({
        sku,
        productLinks: links,
        timestamp: Date.now(),
        quantity,
      });
    }
  });
}
}
